import { useState, useRef, RefCallback } from 'react';

export const useHover = <T extends HTMLElement>(): [RefCallback<T>, boolean] => {
  const [isHovered, setIsHovered] = useState(false);
  const ref = useRef<T | null>(null);

  const setRef: RefCallback<T> = (node) => {
    if (ref.current) {
      ref.current.removeEventListener('mouseenter', handleMouseEnter);
      ref.current.removeEventListener('mouseleave', handleMouseLeave);
    }

    ref.current = node;

    if (ref.current) {
      ref.current.addEventListener('mouseenter', handleMouseEnter);
      ref.current.addEventListener('mouseleave', handleMouseLeave);
    }
  };

  const handleMouseEnter = () => setIsHovered(true);
  const handleMouseLeave = () => setIsHovered(false);

  return [setRef, isHovered];
};